// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .react-calendar__month-view__days__day--weekend {
    color: #6a48da;
    background-color: rgb(255, 255, 255) !important;
  } */
.employee-attendance-page .react-calendar button abbr {
  display: none;
}
.marked-leave {
  background-color: rgb(29, 197, 13) !important;
  color: white !important;
}

.marked-holiday {
  background-color: #c4cce3 !important;
  color: #000 !important;
}

.marked-saturday {
  background-color: purple !important; /* Or any other color you want */
  color: white !important;
}

.holiday-tooltip {
  font-size: 0.8em;
  font-weight: bold;
}
.custom-badge {
  background-color: #425c96 !important ;
  color: white;
}
/* .custom-badge1,
    .last-saturday {
      background-color: #ffa500 !important;
      color: white;
    } */
.custom-badge13 {
  background-color: #c4cce3 !important;
  color: #000 !important;
}
.custom-badge14 {
  background-color: rgb(29, 197, 13) !important;
  color: white !important;
}
.custom-badge15 {
  background-color: #58b1d2 !important;
  color: #000;
  border: 1px solid #dacfcf;
}
.custom-badge13 .last-saturday {
  /* background-color: #3ca8e8; */
  background-color: #fff;
  color: #222;
}
/* .react-calendar__tile:disabled {
      background-color: #dfdfdf;
      color: #000;
    } */
.not-marked {
  background-color: #e39b99 !important;
  color: white !important;
}
.marked-attendance {
  background-color: #8bcfb6 !important;
  color: white !important;
}
.unmarked-working-day {
  /* background-color: #81b2d9 !important; */
  color: white !important;
}
.employee-attendance-page .react-calendar .react-calendar__tile.leave-date,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile.leave-date:enabled:hover,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile.leave-date:enabled:focus,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile--active.leave-date,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile:disabled.leave-date {
  background-color: rgb(255 104 99) !important;
  color: white !important;
}
.leave-request {
  background-color: red !important;
  color: white;
}
.employee-attendance-page .react-calendar .react-calendar__tile.attendance-date,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile.attendance-date:enabled:hover,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile.attendance-date:enabled:focus,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile--active.attendance-date,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile:disabled.attendance-date {
  background-color: #10b981 !important;
  color: white !important;
}
.employee-attendance-page .react-calendar .react-calendar__tile.regularized,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile.regularized:enabled:hover,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile.regularized:enabled:focus,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile--active.regularized,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile:disabled.regularized {
  background-color: #f59e0b !important;
  color: white !important;
}
.employee-attendance-page .react-calendar .react-calendar__tile.absent-date,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile.absent-date:enabled:hover,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile.absent-date:enabled:focus,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile--active.absent-date,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile:disabled.absent-date {
  background-color: #334155 !important;
  color: white !important;
}
.employee-attendance-page
  .react-calendar
  .react-calendar__tile.unmarked-working-day,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile.unmarked-working-day:enabled:hover,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile.unmarked-working-day:enabled:focus,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile--active.unmarked-working-day {
  /* background-color: #81b2d9 !important; */
  color: #ffffff !important;
}
.employee-attendance-page .react-calendar .react-calendar__tile.holiday,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile.holiday:enabled:hover,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile.holiday:enabled:focus,
.employee-attendance-page .react-calendar .react-calendar__tile--active.holiday,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile:disabled.holiday {
  background-color: #e11d48 !important;
  color: #ffffff !important;
}
.employee-attendance-page .react-calendar .late-marker {
  position: relative;
  display: inline-block;
}
.employee-attendance-page .react-calendar .status-dot {
  position: absolute;
  bottom: -2px;
  left: 50%;
  transform: translateX(-50%);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 1px solid #ffffff;
}
.employee-attendance-page .react-calendar .status-dot.attendance-date {
  background-color: #10b981;
}
.employee-attendance-page .react-calendar .status-dot.regularized {
  background-color: #f59e0b;
}
.employee-attendance-page .react-calendar .status-dot.absent-date {
  background-color: #334155;
}
.employee-attendance-page .react-calendar .status-dot.leave-date {
  background-color: rgb(255 104 99);
}
.employee-attendance-page .react-calendar .status-dot.holiday {
  background-color: #e11d48;
}
.employee-attendance-page .react-calendar .status-dot.unmarked-working-day {
  background-color: #81b2d9;
}
.employee-attendance-page .react-calendar .status-dot.late-attendance {
  background-color: #48443d;
}
.employee-attendance-page .react-calendar .react-calendar__tile.late-attendance,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile.late-attendance:enabled:hover,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile.late-attendance:enabled:focus,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile--active.late-attendance,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile:disabled.late-attendance {
  background-color: #48443d !important;
  color: #ffffff !important;
}
.employee-attendance-page .react-calendar .react-calendar__tile.compoff-date,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile.compoff-date:enabled:hover,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile.compoff-date:enabled:focus,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile--active.compoff-date,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile:disabled.compoff-date {
  background-color: #9b59b6 !important;
  color: #ffffff !important;
}
.employee-attendance-page .react-calendar .react-calendar__tile.leave-request,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile.leave-request:enabled:hover,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile.leave-request:enabled:focus,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile--active.leave-request,
.employee-attendance-page
  .react-calendar
  .react-calendar__tile:disabled.leave-request {
  background-color: #ff6933 !important;
  color: #ffffff !important;
}
.employee-attendance-page .react-calendar .late-marker::after {
  content: "L";
  position: absolute;
  top: 2px;
  right: -10px;
  font-size: 8px;
  font-weight: bold;
  color: #ffffff;
  background-color: #48443d;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.employee-attendance-page .react-calendar__tile:disabled {
  background-color: #df1a42;
  color: #ffffff;
}
.employee-leave-balance {
  background-color: #4fd358;
  border-color: #7c3aed;
  color: #ffffff;
}
.employee-leave-taken {
  background-color: rgb(255 104 99);
  border-color: rgb(255 104 99);
  color: #ffffff;
}
.employee-holidays {
  background-color: #e11d48;
  border-color: #e11d48;
  color: #ffffff;
}
.employee-absent {
  background-color: #334155;
  border-color: #334155;
  color: #ffffff;
}
.employee-lopleaves {
  background-color: #59b6af;
  border-color: #59b6af;
  color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/Sidebar/EmployeesAttandance/Employeeattendance.css"],"names":[],"mappings":"AAAA;;;KAGK;AACL;EACE,aAAa;AACf;AACA;EACE,6CAA6C;EAC7C,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,mCAAmC,EAAE,gCAAgC;EACrE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,qCAAqC;EACrC,YAAY;AACd;AACA;;;;OAIO;AACP;EACE,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,6CAA6C;EAC7C,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,+BAA+B;EAC/B,sBAAsB;EACtB,WAAW;AACb;AACA;;;OAGO;AACP;EACE,oCAAoC;EACpC,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;AACA;EACE,0CAA0C;EAC1C,uBAAuB;AACzB;AACA;;;;;;;;;;;;;EAaE,4CAA4C;EAC5C,uBAAuB;AACzB;AACA;EACE,gCAAgC;EAChC,YAAY;AACd;AACA;;;;;;;;;;;;;EAaE,oCAAoC;EACpC,uBAAuB;AACzB;AACA;;;;;;;;;;;;;EAaE,oCAAoC;EACpC,uBAAuB;AACzB;AACA;;;;;;;;;;;;;EAaE,oCAAoC;EACpC,uBAAuB;AACzB;AACA;;;;;;;;;;;;EAYE,0CAA0C;EAC1C,yBAAyB;AAC3B;AACA;;;;;;;;;;;EAWE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;;;;;;;;;;;;EAaE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;;;;;;;;;;;;;EAaE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;;;;;;;;;;;;;EAaE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB","sourcesContent":["/* .react-calendar__month-view__days__day--weekend {\r\n    color: #6a48da;\r\n    background-color: rgb(255, 255, 255) !important;\r\n  } */\r\n.employee-attendance-page .react-calendar button abbr {\r\n  display: none;\r\n}\r\n.marked-leave {\r\n  background-color: rgb(29, 197, 13) !important;\r\n  color: white !important;\r\n}\r\n\r\n.marked-holiday {\r\n  background-color: #c4cce3 !important;\r\n  color: #000 !important;\r\n}\r\n\r\n.marked-saturday {\r\n  background-color: purple !important; /* Or any other color you want */\r\n  color: white !important;\r\n}\r\n\r\n.holiday-tooltip {\r\n  font-size: 0.8em;\r\n  font-weight: bold;\r\n}\r\n.custom-badge {\r\n  background-color: #425c96 !important ;\r\n  color: white;\r\n}\r\n/* .custom-badge1,\r\n    .last-saturday {\r\n      background-color: #ffa500 !important;\r\n      color: white;\r\n    } */\r\n.custom-badge13 {\r\n  background-color: #c4cce3 !important;\r\n  color: #000 !important;\r\n}\r\n.custom-badge14 {\r\n  background-color: rgb(29, 197, 13) !important;\r\n  color: white !important;\r\n}\r\n.custom-badge15 {\r\n  background-color: #58b1d2 !important;\r\n  color: #000;\r\n  border: 1px solid #dacfcf;\r\n}\r\n.custom-badge13 .last-saturday {\r\n  /* background-color: #3ca8e8; */\r\n  background-color: #fff;\r\n  color: #222;\r\n}\r\n/* .react-calendar__tile:disabled {\r\n      background-color: #dfdfdf;\r\n      color: #000;\r\n    } */\r\n.not-marked {\r\n  background-color: #e39b99 !important;\r\n  color: white !important;\r\n}\r\n.marked-attendance {\r\n  background-color: #8bcfb6 !important;\r\n  color: white !important;\r\n}\r\n.unmarked-working-day {\r\n  /* background-color: #81b2d9 !important; */\r\n  color: white !important;\r\n}\r\n.employee-attendance-page .react-calendar .react-calendar__tile.leave-date,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile.leave-date:enabled:hover,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile.leave-date:enabled:focus,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile--active.leave-date,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile:disabled.leave-date {\r\n  background-color: rgb(255 104 99) !important;\r\n  color: white !important;\r\n}\r\n.leave-request {\r\n  background-color: red !important;\r\n  color: white;\r\n}\r\n.employee-attendance-page .react-calendar .react-calendar__tile.attendance-date,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile.attendance-date:enabled:hover,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile.attendance-date:enabled:focus,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile--active.attendance-date,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile:disabled.attendance-date {\r\n  background-color: #10b981 !important;\r\n  color: white !important;\r\n}\r\n.employee-attendance-page .react-calendar .react-calendar__tile.regularized,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile.regularized:enabled:hover,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile.regularized:enabled:focus,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile--active.regularized,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile:disabled.regularized {\r\n  background-color: #f59e0b !important;\r\n  color: white !important;\r\n}\r\n.employee-attendance-page .react-calendar .react-calendar__tile.absent-date,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile.absent-date:enabled:hover,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile.absent-date:enabled:focus,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile--active.absent-date,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile:disabled.absent-date {\r\n  background-color: #334155 !important;\r\n  color: white !important;\r\n}\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile.unmarked-working-day,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile.unmarked-working-day:enabled:hover,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile.unmarked-working-day:enabled:focus,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile--active.unmarked-working-day {\r\n  /* background-color: #81b2d9 !important; */\r\n  color: #ffffff !important;\r\n}\r\n.employee-attendance-page .react-calendar .react-calendar__tile.holiday,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile.holiday:enabled:hover,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile.holiday:enabled:focus,\r\n.employee-attendance-page .react-calendar .react-calendar__tile--active.holiday,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile:disabled.holiday {\r\n  background-color: #e11d48 !important;\r\n  color: #ffffff !important;\r\n}\r\n.employee-attendance-page .react-calendar .late-marker {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n.employee-attendance-page .react-calendar .status-dot {\r\n  position: absolute;\r\n  bottom: -2px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  border: 1px solid #ffffff;\r\n}\r\n.employee-attendance-page .react-calendar .status-dot.attendance-date {\r\n  background-color: #10b981;\r\n}\r\n.employee-attendance-page .react-calendar .status-dot.regularized {\r\n  background-color: #f59e0b;\r\n}\r\n.employee-attendance-page .react-calendar .status-dot.absent-date {\r\n  background-color: #334155;\r\n}\r\n.employee-attendance-page .react-calendar .status-dot.leave-date {\r\n  background-color: rgb(255 104 99);\r\n}\r\n.employee-attendance-page .react-calendar .status-dot.holiday {\r\n  background-color: #e11d48;\r\n}\r\n.employee-attendance-page .react-calendar .status-dot.unmarked-working-day {\r\n  background-color: #81b2d9;\r\n}\r\n.employee-attendance-page .react-calendar .status-dot.late-attendance {\r\n  background-color: #48443d;\r\n}\r\n.employee-attendance-page .react-calendar .react-calendar__tile.late-attendance,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile.late-attendance:enabled:hover,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile.late-attendance:enabled:focus,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile--active.late-attendance,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile:disabled.late-attendance {\r\n  background-color: #48443d !important;\r\n  color: #ffffff !important;\r\n}\r\n.employee-attendance-page .react-calendar .react-calendar__tile.compoff-date,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile.compoff-date:enabled:hover,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile.compoff-date:enabled:focus,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile--active.compoff-date,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile:disabled.compoff-date {\r\n  background-color: #9b59b6 !important;\r\n  color: #ffffff !important;\r\n}\r\n.employee-attendance-page .react-calendar .react-calendar__tile.leave-request,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile.leave-request:enabled:hover,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile.leave-request:enabled:focus,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile--active.leave-request,\r\n.employee-attendance-page\r\n  .react-calendar\r\n  .react-calendar__tile:disabled.leave-request {\r\n  background-color: #ff6933 !important;\r\n  color: #ffffff !important;\r\n}\r\n.employee-attendance-page .react-calendar .late-marker::after {\r\n  content: \"L\";\r\n  position: absolute;\r\n  top: 2px;\r\n  right: -10px;\r\n  font-size: 8px;\r\n  font-weight: bold;\r\n  color: #ffffff;\r\n  background-color: #48443d;\r\n  width: 12px;\r\n  height: 12px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.employee-attendance-page .react-calendar__tile:disabled {\r\n  background-color: #df1a42;\r\n  color: #ffffff;\r\n}\r\n.employee-leave-balance {\r\n  background-color: #4fd358;\r\n  border-color: #7c3aed;\r\n  color: #ffffff;\r\n}\r\n.employee-leave-taken {\r\n  background-color: rgb(255 104 99);\r\n  border-color: rgb(255 104 99);\r\n  color: #ffffff;\r\n}\r\n.employee-holidays {\r\n  background-color: #e11d48;\r\n  border-color: #e11d48;\r\n  color: #ffffff;\r\n}\r\n.employee-absent {\r\n  background-color: #334155;\r\n  border-color: #334155;\r\n  color: #ffffff;\r\n}\r\n.employee-lopleaves {\r\n  background-color: #59b6af;\r\n  border-color: #59b6af;\r\n  color: #ffffff;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
